import React from "react";
import styled from "styled-components";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";

interface AnimatedSectionProps {
  children: React.ReactNode;
  animation?: "fadeInUp" | "fadeInLeft" | "fadeInRight" | "fadeIn" | "scaleIn";
  delay?: number;
  duration?: number;
  className?: string;
}

const AnimatedContainer = styled.div<{
  isVisible: boolean;
  animation: string;
  delay: number;
  duration: number;
}>`
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  transform: ${(props) => {
    if (!props.isVisible) {
      switch (props.animation) {
        case "fadeInUp":
          return "translateY(30px)";
        case "fadeInLeft":
          return "translateX(-30px)";
        case "fadeInRight":
          return "translateX(30px)";
        case "scaleIn":
          return "scale(0.9)";
        default:
          return "none";
      }
    }
    return "none";
  }};
  transition: all ${(props) => props.duration}ms ease-out;
  transition-delay: ${(props) => props.delay}ms;
`;

const AnimatedSection: React.FC<AnimatedSectionProps> = ({
  children,
  animation = "fadeInUp",
  delay = 0,
  duration = 600,
  className,
}) => {
  const { ref, isVisible } = useScrollAnimation({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px",
    triggerOnce: true,
  });

  return (
    <AnimatedContainer
      ref={ref}
      isVisible={isVisible}
      animation={animation}
      delay={delay}
      duration={duration}
      className={className}
    >
      {children}
    </AnimatedContainer>
  );
};

export default AnimatedSection;
